/** Rules a new password must meet, checked here first so mistakes show before sending. */
export function passwordProblem(password: string, confirm: string, email: string): string | null {
  if (password.length < 12) return "Use at least 12 characters. A short sentence works well.";
  if (password.trim().toLowerCase() === email.trim().toLowerCase())
    return "Choose a password that isn't your email address.";
  if (new Set(password).size < 4) return "Choose a password that isn't one character repeated.";
  if (password !== confirm) return "The two passwords don't match.";
  return null;
}

/**
 * Only paths inside the console, so a crafted link can't send people elsewhere after sign-in.
 * The browser's own URL parser has the last word: it reads a backslash after the first slash,
 * or a tab inside a path, as the start of another site's address, and so does this. A path
 * like "/.//evil.example" tidies up to "//evil.example", which a browser would also read as
 * another site, so the tidied path is checked again.
 */
export function safeNext(next: string | null, origin = window.location.origin): string {
  if (!next || !next.startsWith("/")) return "/";
  try {
    const url = new URL(next, origin);
    if (url.origin !== origin) return "/";
    const path = `${url.pathname}${url.search}${url.hash}`;
    if (path.startsWith("//") || new URL(path, origin).origin !== origin) return "/";
    return path;
  } catch {
    return "/";
  }
}
